import Player from '@vimeo/player';

export class VideoModal {
    constructor() {
        // Load the IFrame Player API code asynchronously.
        //var tag = document.createElement('script');
        //tag.src = "https://www.youtube.com/player_api";
        //var firstScriptTag = document.getElementsByTagName('script')[0];
        //firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


        // Open modal
        if (document.querySelector(".modal-btn")) {
            let myNodeList = document.querySelectorAll(".modal-btn");
            let myArray = Array.prototype.slice.call(myNodeList);
            myArray.forEach(function (modalBtn) {
                modalBtn.addEventListener("click", function () {
                    let dataTarget = modalBtn.getAttribute("data-target");
                    let targetModal = document.querySelector(dataTarget);
                    targetModal.classList.add("modal-background-open");
                })
            })
        }
        // Close modal
        if (document.querySelector(".modal-close")) {
            let modalCloseNodeList = document.querySelectorAll(".modal-close");
            let modalCloseArray = Array.prototype.slice.call(modalCloseNodeList);
            modalCloseArray.forEach(function (modalClose) {
                modalClose.addEventListener("click", function () {
                    // Pause video
                    let video = modalClose.parentElement.parentElement.parentElement.querySelector("video");
                    if (!video) {
                        let iframe = modalClose.parentElement.parentElement.parentElement.querySelector("iframe");
                        if (iframe.classList.contains("vimeo")) {
                            //use vimeo player object to pause vimeo
                            var vimeoPlayer = new Player(iframe);
                            if (vimeoPlayer) {
                                vimeoPlayer.pause();
                            }
                        }
                        else {
                            //post message to pause youtube
                            iframe.contentWindow.postMessage(`{"event": "command", "func": "pauseVideo", "args": ""}`, '*');
                        }
                    }
                    else if (video && !video.paused)
                        video.pause();

                    let dataTarget = modalClose.getAttribute("data-target");
                    let targetModal = document.querySelector(dataTarget);
                    targetModal.classList.remove("modal-background-open");
                })
            })
        }

        if (document.querySelector(".modal-background")) {
            let modalCloseNodeList = document.querySelectorAll(".modal-background");
            let modalCloseArray = Array.prototype.slice.call(modalCloseNodeList);
            modalCloseArray.forEach(function (modalClose) {
                modalClose.addEventListener("click", function () {
                    // Pause video
                    let video = modalClose.querySelector("video");
                    if (video && !video.paused)
                        video.pause();

                    modalClose.classList.remove("modal-background-open");
                })
            })
        }

        if (document.querySelector(".modal-container")) {
            let modalCloseNodeList = document.querySelectorAll(".modal-container");
            let modalCloseArray = Array.prototype.slice.call(modalCloseNodeList);
            modalCloseArray.forEach(function (modalClose) {
                modalClose.querySelector("video").addEventListener("click", function (e) {
                    e.stopPropagation();
                    let myVideo = modalClose.querySelector("video");
                    if (myVideo.paused)
                        myVideo.play();
                    else
                        myVideo.pause();
                })
            })
        }
    }

    
    //public playerIframes: any = document.querySelectorAll(".youtube");
    //public playerIframesArr: any = [].slice.call(this.playerIframes);

    //public players: any = new Array(this.playerIframesArr.length);
    //public waypoints: any = new Array(this.playerIframesArr.length);



    //// when youtube stuff is ready
    //onYouTubeIframeAPIReady() {

    //    // create yt players
    //    this.playerIframesArr.forEach(function (playerIframe, i) {
    //        this.players[i] = new YT.Player((playerIframe as any).id, {
    //            videoId: (playerIframe as any).getAttribute("data-target"),
    //            events: { /* no events set */ }
    //        })
    //    })
    //}
}




// WEBPACK FOOTER //
// ./Static/javascript/modules/video-modal.ts